// Flow types automatically removed

import { Fragment } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy.js';
import { FormattedMessage } from 'dibs-react-intl';
import getter from 'dibs-object-getter';
import { Button } from 'dibs-elements/exports/Button.tsx';
import { InteriorsLandingModuleHeader } from './InteriorsLandingModuleHeader.jsx';
import InteriorsLandingDesignerItem from './InteriorsLandingDesignerItem.tsx';
import { InteriorsLandingViewAllButton } from './InteriorsLandingViewAllButton.jsx';
import styles from './styles/InteriorsLandingDesigners.module.css';
function InteriorsLandingDesignersComponent({ designersModule }) {
    const showPrimaryDesigners = getter(designersModule)
        .at('primaryDesignersModule')
        .value('isVisible');
    const primaryDesigners = (
        getter(designersModule).at('primaryDesignersModule').value('items') || []
    ).filter(Boolean);
    const showSecondaryDesigners = getter(designersModule)
        .at('secondaryDesignersModule')
        .value('isVisible');
    const secondaryDesigners = (
        getter(designersModule).at('secondaryDesignersModule').value('items') || []
    ).filter(Boolean);
    const showTertiaryDesigners = getter(designersModule)
        .at('tertiaryDesignersModule')
        .value('isVisible');
    const tertiaryDesigners = (
        getter(designersModule).at('tertiaryDesignersModule').value('items') || []
    ).filter(Boolean);
    const showViewAll = showPrimaryDesigners || showSecondaryDesigners || showTertiaryDesigners;
    return (
        <Fragment>
            <InteriorsLandingModuleHeader
                header={getter(designersModule).value('designersHeadModule') || {}}
                module="designers"
            />
            {showPrimaryDesigners && (
                <div className="rowFlex" data-tn="interiors-landing-primary-designers-row">
                    {primaryDesigners.map((item, index) => (
                        <InteriorsLandingDesignerItem
                            designer={item}
                            type="primary"
                            key={`designer-primary-${index}`}
                        />
                    ))}
                </div>
            )}
            {showSecondaryDesigners && (
                <div className="rowFlex" data-tn="interiors-landing-secondary-designers-row">
                    {secondaryDesigners.map((item, index) => (
                        <InteriorsLandingDesignerItem
                            designer={item}
                            type="secondary"
                            key={`designer-secondary-${index}`}
                        />
                    ))}
                </div>
            )}
            {showTertiaryDesigners && (
                <div className="rowFlex" data-tn="interiors-landing-tertiary-designers-row">
                    {tertiaryDesigners.map((item, index) => (
                        <InteriorsLandingDesignerItem
                            designer={item}
                            type="tertiary"
                            key={`designer-tertiary-${index}`}
                        />
                    ))}
                </div>
            )}
            {showViewAll && (
                <div className="rowFlex" data-tn="interiors-landing-view-all-designers-row">
                    <div className={`colXs12 ${styles.viewAllWrapper}`}>
                        <InteriorsLandingViewAllButton>
                            <Button
                                dataTn="interiors-landing-view-all-firms"
                                href="/design-firms/"
                                type="secondary"
                                className={styles.viewAllCta}
                            >
                                <FormattedMessage
                                    id="abt.interiorsLanding.viewAllDesigners"
                                    defaultMessage="See All"
                                />
                            </Button>
                        </InteriorsLandingViewAllButton>
                    </div>
                </div>
            )}
        </Fragment>
    );
}
export const InteriorsLandingDesigners = createFragmentContainer(
    InteriorsLandingDesignersComponent,
    {
        designersModule: graphql`
            fragment InteriorsLandingDesigners_designersModule on InteriorsLandingPage {
                designersHeadModule {
                    ...InteriorsLandingModuleHeader_header
                }
                primaryDesignersModule {
                    isVisible
                    items {
                        ...InteriorsLandingDesignerItem_designer
                    }
                }
                secondaryDesignersModule {
                    isVisible
                    items {
                        ...InteriorsLandingDesignerItem_designer
                    }
                }
                tertiaryDesignersModule {
                    isVisible
                    items {
                        ...InteriorsLandingDesignerItem_designer
                    }
                }
            }
        `,
    }
);
